module.exports = __webpack_public_path__ + "img/app.6438a386.png";